import { createApp } from 'vue'
import mitt from 'mitt'

export default (app: ReturnType<typeof createApp>) => {
  const mitter = mitt()
  app.provide('mitter', mitter)
}
